import { useIntl } from 'react-intl'
import SwitchComponent from '../../../components/stories/atoms/switch'
import {
  ShowInactiveProjectContainer,
  ShowInactiveProjectLabel
} from '../styled-component'
import PropTypes from 'prop-types'

const ShowInactiveProjectSwitch = ({
  onCheckedChange = () => {},
  checked = false
}) => {
  const { formatMessage } = useIntl()

  return (
    <ShowInactiveProjectContainer>
      <ShowInactiveProjectLabel data-checked={checked}>
        {formatMessage({ id: 'show_inactive_projects' })}
      </ShowInactiveProjectLabel>
      <SwitchComponent checked={checked} onCheckedChange={onCheckedChange} />
    </ShowInactiveProjectContainer>
  )
}

ShowInactiveProjectSwitch.propTypes = {
  onCheckedChange: PropTypes.func,
  checked: PropTypes.bool
}

export default ShowInactiveProjectSwitch
